var path = 'app/scripts/modules/openstack/src/region/regionSelectField.directive.html';
var html = "<select-field value=\"model\" options=\"regions\"\n              label=\"{{label}}\" label-column-size=\"{{labelColumnSize}}\"\n              help-key=\"{{helpKey}}\" on-change=\"onChange({region: value})\"\n              read-only=\"readOnly\" allow-no-selection=\"allowNoSelection\"\n              no-options-message=\"{{noOptionsMessage}}\" no-selection-message=\"{{noSelectionMessage}}\"></select-field>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/openstack/src/region/regionSelectField.directive.html
// module id = 3716
// module chunks = 0